const calltoaction = {
  touch1: "Touchez l'ecran",
  touch2: 'pour commencer',
};

export default calltoaction;
